import axios from 'axios'
import library from '../../../utils/Library'

export const getSuscriberRefId = async (params) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('subscribers') + '/getSubscriberCorpEntities'

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: params
  })
}
